<template>
  <DrawablePhotoV1OrV2
    :image="imageObject"
    :drawing="drawing"
    :width="480"
    :height="240"
    :show-thumbnail="false"
    :colors="[{ color: '#000000', marker: '#ffffff' }]"
    :title="$t('Sign here')"
    :remove-button-title="$t('Remove signature')"
    :can-be-deleted="false"
    @change="valueChanged"
  />
</template>

<script>
  import { DrawablePhotoV1OrV2 } from '@/_legacy/components/DrawablePhoto/DrawablePhotoV1OrV2';

  export default {
    name: 'ConductInspectionItemQuestionSignature',
    components: { DrawablePhotoV1OrV2 },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {
      drawing() {
        return this.item.response && this.item.response.drawing
          ? this.item.response.drawing
          : null;
      },
      imageObject() {
        return { drawing: this.drawing };
      },
    },
    methods: {
      valueChanged(drawing) {
        this.$emit('change', {
          uuid: this.item.uuid,
          response: drawing ? { drawing } : null,
          responded: !!drawing,
        });
      },
    },
  };
</script>
